/* Browse by Color / Wood — horizontal slider once the row no longer fits.
 *
 * The grid stays a grid up to the section's threshold; past it the track scrolls and
 * these arrows page through it. Everything degrades cleanly: with JS off the track is
 * still a native horizontal scroller, and the arrows are only revealed once we know
 * there is something to scroll to. */
class ColorNavSlider extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-slider')) return;
    this.track = this.querySelector('[data-cn-track]');
    this.prev = this.querySelector('[data-cn-prev]');
    this.next = this.querySelector('[data-cn-next]');
    if (!this.track) return;

    this.onScroll = () => this.sync();
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.prev?.addEventListener('click', () => this.page(-1));
    this.next?.addEventListener('click', () => this.page(1));

    // arrow keys move the track when it has focus
    this.track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); this.page(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); this.page(-1); }
    });

    this.sync();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  /** One page is the visible width less a sliver, so the next item is already peeking. */
  page(direction) {
    const step = Math.max(this.track.clientWidth - 80, 160);
    this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  sync() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const scrollable = scrollWidth - clientWidth > 4;
    // no overflow, no arrows — a half-empty row with dead arrows looks broken
    this.toggleAttribute('data-scrollable', scrollable);
    if (this.prev) this.prev.hidden = !scrollable || scrollLeft <= 4;
    if (this.next) this.next.hidden = !scrollable || scrollLeft >= scrollWidth - clientWidth - 4;
  }
}

if (!customElements.get('color-nav-slider')) {
  customElements.define('color-nav-slider', ColorNavSlider);
}
